import { Button, Tooltip, useComputedColorScheme } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

import { useSelectedClaimStore } from 'store/SelectedClaimStore';

interface InternalTogglePreviewButtonProps {}

export const InternalTogglePreviewButton: React.FC<
  InternalTogglePreviewButtonProps
> = () => {
  const toolbarIconSize = 24;
  const toolbarButtonSize = 32;
  const computedColorScheme = useComputedColorScheme('dark');
  const { showPreview, setShowPreview } = useSelectedClaimStore();

  const handleTogglePreview = () => {
    setShowPreview(!showPreview);
  };

  return (
    <Tooltip label="Toggle Patient Preview" position="top">
      <Button
        onClick={handleTogglePreview}
        variant="subtle"
        size="xs"
        p={0}
        style={{
          width: toolbarButtonSize,
          height: toolbarButtonSize,
          minWidth: toolbarButtonSize,
        }}
        aria-label="Toggle patient preview"
        aria-pressed={showPreview}
      >
        <IconInfoCircle
          size={toolbarIconSize}
          color={computedColorScheme === 'dark' ? 'white' : 'black'}
        />
      </Button>
    </Tooltip>
  );
};
